/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClLineKBar 的实体定义
import {
    _fillRect,
    _drawRect,
    _setLineWidth,
    _getTxtWidth,
    _drawTxt,
    _drawHline,
    _drawVline,
    _drawBegin,
    _drawEnd,
    _drawLineAlone,
} from './cl.draw'

import {
    CHART_LAYOUT,
} from '../cl.chart.res'

import {
    copyJsonOfDeep,
    updateJsonOfDeep,
    offsetRect,
    getGradientColors,
} from '../cl.utils'
import {
    initCommonInfo,
    checkLayout
} from './cl.chart.init'

// 创建时必须带入父类，后面的运算定位都会基于父节点进行；
// 这个类仅仅是画图, 因此需要把可以控制的rect传入进来
/**
 * Class representing ClChartText
 * @export
 * @class ClChartText
 */
export default class ClChartText {
    constructor(father) {
        initCommonInfo(this, father)
    }
    init(cfg, callback) {
        this.callback = callback
        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 25,
            height: 25
        }
        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)
        this.config = copyJsonOfDeep(cfg.config)
        // Make some checks on the configuration
        this.checkConfig()
    }
    checkConfig() {
        checkLayout(this.layout)
        this.font = this.config.font || this.layout.title.font
        this.pixel = this.config.pixel || this.layout.title.pixel
    }
    onPaint() {

        _fillRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height, this.color.back)
        // console.log(this.config);
        
        if (this.config.visible && this.config.visible === false) return

        let clr = this.color.txt
        const spaceY = Math.round((this.rectMain.height - this.pixel) / 2)
        const yy = this.rectMain.top + spaceY
        const ww = _getTxtWidth(this.context, this.config.label, this.font, this.pixel) 
        const spaceX = Math.round((this.rectMain.width - ww) / 2)
        const xx = this.rectMain.left + spaceX

        _drawTxt(this.context, xx, yy, this.config.label,
                this.font, this.pixel, clr)
        
    }
}